export default __webpack_public_path__ + "static/media/box.0bce05a4.png";